import { KatIcon } from "@amzn/katal-react";
import classnames from "classnames";
import React, { type FC } from "react";
import type {
  DocumentDetails,
  InboundDocument,
  MetadataOverrides,
} from "src/api/interfaces/inbound_document";
import AgentCard from "src/components/Pages/DocumentInbound/Header/AgentCard";
import DocumentDetailCard from "src/components/Pages/DocumentInbound/Header/DocumentDetailsCard";
import styles from "src/styles.module.scss";

const DocumentDetailHeader: FC<DocumentDetailsHeaderProps> = ({
  documentDetails,
  metadataOverrides,
  content,
}) => {
  return (
    <div
      className={classnames(
        styles.flex,
        styles.flex_direction_row,
        styles.flex_nowrap,
        styles.w_100,
        styles.justify_start,
        styles.mt_6,
        styles.align_items_center
      )}
    >
      {documentDetails.issuer ? (
        <>
          <AgentCard
            agent={documentDetails.issuer}
            className={classnames(styles.mr_6, styles.min_w_30)}
          />
          <KatIcon
            name={"keyboard_control"}
            className={classnames(styles.mr_6)}
          />
        </>
      ) : null}
      <DocumentDetailCard
        documentDetails={documentDetails}
        metadataOverrides={metadataOverrides}
        className={classnames(styles.mr_6, styles.min_w_30)}
        content={content}
      />
      {documentDetails.recipient ? (
        <>
          <KatIcon
            name={"keyboard_control"}
            className={classnames(styles.mr_6)}
          />
          <AgentCard
            agent={documentDetails.recipient}
            className={classnames(styles.min_w_30)}
          />
        </>
      ) : null}
    </div>
  );
};

export interface DocumentDetailsHeaderProps {
  documentDetails: DocumentDetails;
  metadataOverrides?: MetadataOverrides;
  content?: InboundDocument;
}

export default DocumentDetailHeader;
